// extracted by mini-css-extract-plugin
export var box = "_3y-0";
export var check = "_3y-1";
export var checkboxButton = "_3y-6";
export var checkboxGroup = "_3y-5";
export var disabled = "_3y-7";
export var ghost = "_3y-9";
export var input = "_3y-2";
export var label = "_3y-4";
export var normal = "_3y-8";
export var uncheck = "_3y-3";